import { fb, validators } from '../../../lib/form';

export function getFunctionModel(data) {

  let serviceList = ["The Pavilion", "Creekside", "Cellar Restaurant", "Bridgey Bar"].map(x => { return { name: x, value: x }});
  serviceList = [ {name: "Preferred Dining Space", value: ""}, ...serviceList];

  const model = fb.group({
    name: [data.name || '', [validators.Required()], { label: 'Name', type: 'text' }],
    phone: [data.phone || '', [validators.Required()], { label: 'Phone', type: 'text' }],
    email: [data.email || '', [validators.Required(), validators.Email()], { label: 'Email', type: 'email' }],
    occasion: [data.occasion || '', [validators.Required()], { label: 'Occasion', type: 'text'}],
    people: [data.people || '', [validators.Required()], { label: 'How many people', type: 'number'}],
    date: [data.date || '', [validators.Required()], { label: 'Date', type: 'text'}],
    time: [data.time || '', [validators.Required()], { label: 'Time', type: 'text'}],
    services: [data.services || '', [validators.Required()], { label: null, type: 'select', options: serviceList }],
    enquiry: [data.enquiry || '', [], { label: 'Additional info', type: 'textarea' }],
    //attachments: [data.attachments || '', [], { label: 'Attachments', type: 'file' }]
  }); 
  return model;
}